import type { CollectionMeta } from "./types";

export function parseMeta(meta: unknown): CollectionMeta {
  if (!meta) return {};
  if (Array.isArray(meta)) {
    try {
      return JSON.parse(meta[0]) as CollectionMeta;
    } catch {
      return {};
    }
  }
  if (typeof meta === "object") return meta as CollectionMeta;
  return {};
}
